/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CommunicationPreferences/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckboxReadOnly from 'DesignSystem/TysiaCheckboxReadOnly/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CommunicationPreferences({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/CommunicationPreferences"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let leadMetadataPersonPhonedetailsContactconsentsmsValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.person.phoneDetails.contactConsentSms',
})
let leadMetadataResponsiblePhonedetailsContactconsentsmsValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.responsible.phoneDetails.contactConsentSms',
})
let leadMetadataPersonOptinsEmailAgreeonmarketingValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.person.optins.email.agreeOnMarketing',
})
let leadMetadataPersonOptinsPhoneAgreeonmarketingValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.person.optins.phone.agreeOnMarketing',
})
let leadMetadataResponsibleOptinsPhoneAgreeonmarketingValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.responsible.optins.phone.agreeOnMarketing',
})
let leadMetadataResponsibleOptinsEmailAgreeonmarketingValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.responsible.optins.email.agreeOnMarketing',
})
let aggregateData = fromAggregate.any(leadMetadataPersonPhonedetailsContactconsentsmsValueData, leadMetadataResponsiblePhonedetailsContactconsentsmsValueData, leadMetadataPersonOptinsEmailAgreeonmarketingValueData, leadMetadataPersonOptinsPhoneAgreeonmarketingValueData, leadMetadataResponsibleOptinsPhoneAgreeonmarketingValueData, leadMetadataResponsibleOptinsEmailAgreeonmarketingValueData)
let leadMetadataPersonPhonedetailsAgreeonsmsValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.person.phoneDetails.agreeOnSms',
})
let leadMetadataResponsiblePhonedetailsAgreeonsmsValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.responsible.phoneDetails.agreeOnSms',
})
let leadMetadataPersonOptinsEmailAgreeonconsentValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.person.optins.email.agreeOnConsent',
})
let leadMetadataPersonOptinsPhoneAgreeonconsentValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.person.optins.phone.agreeOnConsent',
})
let leadMetadataResponsibleOptinsPhoneAgreeonconsentValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.responsible.optins.phone.agreeOnConsent',
})
let leadMetadataResponsibleOptinsEmailAgreeonconsentValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'metadata.responsible.optins.email.agreeOnConsent',
})
let aggregateData1 = fromAggregate.any(leadMetadataPersonPhonedetailsAgreeonsmsValueData, leadMetadataResponsiblePhonedetailsAgreeonsmsValueData, leadMetadataPersonOptinsEmailAgreeonconsentValueData, leadMetadataPersonOptinsPhoneAgreeonconsentValueData, leadMetadataResponsibleOptinsPhoneAgreeonconsentValueData, leadMetadataResponsibleOptinsEmailAgreeonconsentValueData)
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Communication Opt Ins"
 level="h4"
/>
<div
  data-testid="CommunicationPreferences.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-17snvw': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="CommunicationPreferences.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 marginRight={dtSpaceXs}
 text="Opted into marketing communications"
/>
<TysiaCheckboxReadOnly
  viewPath={`${viewPath}/TysiaCheckboxReadOnly`}
 data="lead.metadata.person.phoneDetails.contactConsentSms"
 data="lead.metadata.responsible.phoneDetails.contactConsentSms"
 data="lead.metadata.person.optins.email.agreeOnMarketing"
 data="lead.metadata.person.optins.phone.agreeOnMarketing"
 data="lead.metadata.responsible.optins.phone.agreeOnMarketing"
 data="lead.metadata.responsible.optins.email.agreeOnMarketing"
 aggregate="/Data/aggregate.js any"
 value={aggregateData}
/>
</div>
<div
  data-testid="CommunicationPreferences.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 marginRight={dtSpaceXs}
 text="Opted into practice communication"
/>
<TysiaCheckboxReadOnly
  viewPath={`${viewPath}/TysiaCheckboxReadOnly`}
 data="lead.metadata.person.phoneDetails.agreeOnSms"
 data="lead.metadata.responsible.phoneDetails.agreeOnSms"
 data="lead.metadata.person.optins.email.agreeOnConsent"
 data="lead.metadata.person.optins.phone.agreeOnConsent"
 data="lead.metadata.responsible.optins.phone.agreeOnConsent"
 data="lead.metadata.responsible.optins.email.agreeOnConsent"
 aggregate="/Data/aggregate.js any"
 value={aggregateData1}
/>
</div>
</div>
{children}
</React.Fragment>)
}